import '../css/Home.css';

const Home = () => {
  return (
      <div className="flex h-screen bg-fefae0 items-center justify-left p-20 mainBox">
          <h1 className="homeH1">OnBoarding</h1>
      </div>
  );
}

export default Home